import React from "react";
import { Checkbox } from "@campgladiator/cgui-core.atoms.checkbox";
import { Paragraph } from "@campgladiator/cgui-core.atoms.typography";
import styles from "./TermsCheckbox.module.scss";

type TermsCheckboxProps = {
  onChangeTermsCheckbox: (isChecked: boolean) => void;
  onClickViewTerms?: () => void;
  hasTrainerGrants: boolean;
  showTermsLink?: boolean;
};

const TermsCheckbox = ({
  showTermsLink = false,
  onClickViewTerms = () => {},
  onChangeTermsCheckbox,
  hasTrainerGrants,
}: TermsCheckboxProps) => {
  const termsAndConditionsLabel = !hasTrainerGrants ? (
    <>
      I have read and agree to the{" "}
      {showTermsLink ? <u onClick={onClickViewTerms}>terms</u> : "terms"}
    </>
  ) : (
    <>
      FOR TRAINERS ONLY: By checking this box, I, as the CG Trainer, confirm
      that I have discussed and explained each of the above membership details
      to this member
    </>
  );

  return (
    <div className={styles.terms}>
      <Checkbox onStateChange={onChangeTermsCheckbox}>
        <Paragraph size="small" weight="book" className={styles.label}>
          {termsAndConditionsLabel}
        </Paragraph>
      </Checkbox>
    </div>
  );
};

export default TermsCheckbox;
